export default {
  poweredBy: `
<div class="{{cssClasses.root}}">
  Search by
  <a class="{{cssClasses.link}}" href="{{url}}" target="_blank">Algolia</a>
</div>`,
};



// WEBPACK FOOTER //
// ./~/instantsearch.js/src/widgets/search-box/defaultTemplates.js